<div class="col-sm-12">
  <div class="row">
    <div class="col-sm-7">
      <b i18n>Company Logo</b>
      <p i18n>
        To Change your company logo, click browse and select your desired image.
        Then click upload. Accepted image extenstions are .png, .jpg, and .jpeg.
        For best logo appearance, choose an image that is 200 pixels wide.
      </p>
      <form #f="ngForm" (ngSubmit)="uploadFile()">
          <div class="input-group" style="margin:2px;">
              <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="logoFile"
                               accept=".png, .jpg, .jpeg, .gif, .bmp, .tif, .tiff, img/jpeg, img/gif, img/bmp, img/tif"></app-file-upload>
              <button class="btn btn-bidit-action" type="Submit" name="submitImage" value="submitImage" id="button-addon1" i18n>Upload</button>
          </div>
      </form>
    </div>
    <div class="col-sm-5 float-right">
      <form *ngIf="dealer && dealer.dealer_Logo != null" #f="ngForm" (ngSubmit)="deleteLogo(f)">
        <div>
          <app-dealer-logo></app-dealer-logo>
          {{dealer.dealer_Logo}}

          <button type="submit" value="delete" class="btn btn-bidit-action btn-sm" style="margin-top:5px;" i18n>Remove Logo</button>
        </div>
      </form>
    </div>
  </div>

    
</div>
